export default class ProviderInfo {
    providerKey = null
    providerId = null
    name = null
    financingName = null
    logo = null
    altLogo = null
    footerLogo = null
    paymentCalculatorRecalculatingModal = false
    minOffersWithPrequalifiedAmount = false
    fetchPaymentPlansOnPreAuth = true
    fetchPaymentPlansOnResume = false
    subLender = null
    paymentPlanFilterOverrides = null
    selectOfferWithPrequalifiedAmount = false
    productType = null
    acceptOfferOnSelectOffer = false
    altProduct = null
    canFinishWithExistingAccount = false

    constructor({
                    providerId = null,
                    name = null,
                    financingName = null,
                    logo = null,
                    altLogo = null,
                    footerLogo = null,
                    paymentCalculatorRecalculatingModal = false,
                    minOffersWithPrequalifiedAmount = false,
                    fetchPaymentPlansOnPreAuth = true,
                    fetchPaymentPlansOnResume = false,
                    subLender = null,
                    paymentPlanFilterOverrides = null,
                    selectOfferWithPrequalifiedAmount = false,
                    productType = null,
                    acceptOfferOnSelectOffer = false,
                    altProduct = null,
                    canFinishWithExistingAccount = false,
    }) {
        this.providerId = providerId
        this.name = name
        this.financingName = financingName
        this.logo = logo
        this.altLogo = altLogo
        this.footerLogo = footerLogo
        this.paymentCalculatorRecalculatingModal = paymentCalculatorRecalculatingModal
        this.minOffersWithPrequalifiedAmount = minOffersWithPrequalifiedAmount
        this.fetchPaymentPlansOnPreAuth = fetchPaymentPlansOnPreAuth
        this.fetchPaymentPlansOnResume = fetchPaymentPlansOnResume
        this.subLender = subLender
        this.paymentPlanFilterOverrides = paymentPlanFilterOverrides
        this.selectOfferWithPrequalifiedAmount = selectOfferWithPrequalifiedAmount
        this.productType = productType
        this.acceptOfferOnSelectOffer = acceptOfferOnSelectOffer
        this.altProduct = altProduct
        this.canFinishWithExistingAccount = canFinishWithExistingAccount
    }

}
